<template>
  <div style="background-color: #f8f8f8">
    <section>
      <b-container>
        <b-row>
          <b-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
            class="bg-white section__border-radius"
          >
            <label class="m-0 text-small" for="">Doc. Identidad</label>
            <b-form-input
              v-on:keyup.enter="searchClient"
              class="border-none section__filter-small grey-input"
              v-model.trim="identityDocument"
              placeholder="Buscar cliente"
            ></b-form-input>
          </b-col>
          <b-col cols="2" xs="12" sm="12" md="12" lg="2">
            <b-button @click="searchClient" class="rounded-button border-none">
              <font-awesome-icon icon="search" />
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="margin-two-top">
      <b-container>
        <div class="bg-white section__border-radius padding-all-section col-12">
          <b-row>
            <b-col md="12">
              <h6 class="bold-700">Editar información del cliente</h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="3" lg="3">
              <b-form-group label="Tipo de documento" label-for="input-10">
                <b-form-input
                  id="input-10"
                  v-model="dataClient.dadDocumentType"
                  type="text"
                  required
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3" lg="3">
              <b-form-group label="Nro documento" label-for="input-11">
                <b-form-input
                  id="input-11"
                  v-model="dataClient.identityDocument"
                  type="text"
                  required
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="4" lg="3">
              <b-form-group label="Nombre *" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="dataClient.names"
                  type="text"
                  required
                  placeholder="Ingrese el nombre"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4" lg="3">
              <b-form-group label="Apellido Paterno *" label-for="input-13">
                <b-form-input
                  id="input-13"
                  v-model="dataClient.lastName"
                  type="text"
                  required
                  placeholder="Ingrese el apellido"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <b-form-group label="Apellido Materno *" label-for="input-13">
                <b-form-input
                  id="input-13"
                  v-model="dataClient.motherLastName"
                  type="text"
                  required
                  placeholder="Ingrese el apellido"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-show="dataClient.identityDocument">
            <b-col md="12">
              <b-button class="bg-orange-btn" @click="updateClient">
                Guardar
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>
    <section class="margin-two-top">
      <b-container>
        <div class="bg-white section__border-radius padding-all-section col-12">
          <b-row>
            <b-col md="12">
              <h6 class="bold-700">Editar Teléfonos</h6>
            </b-col>
          </b-row>

          <b-row v-show="dataClient.phones.length">
            <b-col cols="12" md="6" lg="6">
              <b-table
                :items="dataClient.phones"
                :fields="fieldsPhones"
                ref="selectableTable"
                selectable
                :select-mode="selectMode"
                :tbody-tr-class="rowClass"
                @row-selected="onRowSelectedMail"
              >
                <template v-slot:cell(contact)="row">
                  <b-form-input type="number" v-model="row.item.contact" />
                </template>
                <template v-slot:cell(active)="row">
                  <span v-if="row.item.active">ACTIVO</span>
                  <span v-else>INACTIVO</span>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    size="sm"
                    @click="updateMailClient(row.item, $event.target)"
                    class="mr-1 bg-orange-btn"
                  >
                    GUARDAR
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>
    <section class="margin-two-top">
      <b-container>
        <div class="bg-white section__border-radius padding-all-section col-12">
          <b-row>
            <b-col md="12">
              <h6 class="bold-700">Editar Correos</h6>
            </b-col>
          </b-row>

          <b-row v-show="dataClient.mails.length">
            <b-col cols="12" md="6" lg="6">
              <b-table
                :items="dataClient.mails"
                :fields="fieldsMails"
                ref="selectableTable"
                selectable
                :select-mode="selectMode"
                @row-selected="onRowSelected"
              >
                <template v-slot:cell(contact)="row">
                  <b-form-input type="text" v-model="row.item.contact" />
                </template>
                <template v-slot:cell(active)="row">
                  <span v-if="row.item.active">ACTIVO</span>
                  <span v-else>INACTIVO</span>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    size="sm"
                    @click="updatePhoneClient(row.item, $event.target)"
                    class="mr-1 bg-orange-btn"
                  >
                    GUARDAR
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>
    <section class="margin-two-top">
      <b-container>
        <div class="bg-white section__border-radius padding-all-section col-12">
          <b-row>
            <b-col md="12">
              <h6 class="bold-700">Editar Direcciones</h6>
            </b-col>
          </b-row>

          <b-row v-show="dataClient.directions.length">
            <b-col cols="12" md="12" lg="12">
              <b-table
                :items="dataClient.directions"
                :fields="fieldsDirections"
                ref="selectableTable"
                selectable
                :select-mode="selectMode"
                @row-selected="onRowSelected"
              >
                <template v-slot:cell(street)="row">
                  <b-form-input type="text" v-model="row.item.street" />
                </template>
                <template v-slot:cell(number)="row">
                  <b-form-input type="text" v-model="row.item.number" />
                </template>
                <template v-slot:cell(Referencia)="row">
                  <b-form-input type="text" v-model="row.item.Referencia" />
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    size="sm"
                    @click="updateClientAdress(row.item, $event.target)"
                    class="mr-1  bg-orange-btn"
                  >
                    GUARDAR
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import {createLogs} from '../../assets/js/common'
import { mapState } from "vuex";
export default {
  name: "Clientes",
  

  data() {
    return {
      selectedPhone: "",
      selectMode: "single",
      identityDocument: "",
      dataClient: {
        names: "",
        lastName: "",
        motherLastName: "",
        identityDocument: "",
        dadDocumentType: "",
        phones: [],
        mails: [],
        directions: [],
      },
      fieldsPhones: [
        { key: "contact", label: "Teléfono" },
        { key: "active", label: "Activo" },
        { key: "actions", label: "" },
      ],
      fieldsMails: [
        { key: "contact", label: "Correo" },
        { key: "active", label: "Activo" },
        { key: "actions", label: "" },
      ],
      selectedMail: "",
      fieldsDirections: [
        { key: "street", label: "Calle" },
        { key: "number", label: "Número" },
        { key: "reference", label: "Referencia" },
        { key: "actions", label: "" },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    let menu = store.getters["module/optionsMenu"];
    let perfil = store.getters["module/profile"];
    let authProvider = menu.some((m) => m.id ==33);
    if (authProvider&&perfil!=="PROVEEDOR") next();
    else next({ name: "BlockedPage" });
  },
  computed:{
    ...mapState("module", [
      "username",
      "token"
    ]),
  },
  methods: {
    onRowSelected(item) {
      console.log(item);
      this.selectedPhone = item[0].id;
    },
    onRowSelectedMail(item) {
      this.selectedMail = item[0].id;
    },
    async searchClient() {
      try {
        
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_CLIENT_CORE_BASE +
            "/clients/document/" +
            this.identityDocument,
            {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        createLogs(response.config.url,this.username,response.config.method,this.$router.history.current.path);
        this.dataClient = response.data;
      } catch (error) {
        this.hasError = true;
        this.messageOS = error.response.data.message;
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async updateClient() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.patch(
          process.env.VUE_APP_CLIENT_CORE_BASE +
            "/clients/" +
            this.dataClient.id,
          this.dataClient,
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
         createLogs(response.config.url,this.username,response.config.method,this.$router.history.current.path);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(response.data);
      } catch (error) {
         createLogs(error.response.config.url,this.username,error.response.config.method,this.$router.history.current.path);
        let values = { variant: "danger", msg: error.response?error.response.data.message:"Hubo un error" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    rowClass(item, type) {
      if (!item || type !== "row" || !this.selectedPhone) return;
      if (item.id == this.selectedPhone.id) return "table-success";
    },
    async updatePhoneClient(item) {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.patch(
          process.env.VUE_APP_CLIENT_CORE_BASE + "/contacts/" + item.id,
          item,
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(response.data);
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    async updateMailClient(item) {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.patch(
          process.env.VUE_APP_CLIENT_CORE_BASE + "/contacts/" + item.id,
          item,
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(response.data);
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }

    },
    async updateClientAdress(item) {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.patch(
          process.env.VUE_APP_CLIENT_CORE_BASE + "/directions/" + item.id,
          item,
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(response.data);
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
  },
};
</script>

<style>
.margin-two-top {
  margin-top: 3%;
}
.padding-all-section {
  padding: 50px;
}
.bold-700 {
  font-weight: 700;
}
</style>
